import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { getMallList } from 'app/api/mall';
import { addTier, getTierById, getTierMaster, updateTier } from 'app/api/tier';
import {
  defaulttierValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { APP_CONSTANTS } from 'app/constants/app-constants';

const useCreateDefaultTier = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [pageLoading, setPageLoading] = useState(false);
  const [mallList, setMallList] = useState([]);
  const [masterList, setMasterList] = useState([]);
  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    tierType: 'default',
    tierDescription: 'default',
    tierId: '',
    mallId: '',
    rangeStart: '',
    rangeEnd: '',
    status: true,
    name: '',
    discount: '',
    priority: '',
  });

  const supportId = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    getMallListforDropdown();
    getMasterList();
  }, []);

  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    if (masterList?.length > 0 && supportId && !dataLoaded) {
      loadStoreData(supportId);
      setDataLoaded(true);
    }
  }, [masterList, supportId]);

  async function getMallListforDropdown() {
    setPageLoading(true);
    let response = await getMallList(1);
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.malls?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
        };
      });
      setMallList(temp);
    } else {
      Toast.error(
        response?.data ? response?.data : Message?.Error?.COMMON_MESSAGE
      );
    }
  }

  async function getMasterList() {
    setPageLoading(true);
    let response = await getTierMaster();
    setPageLoading(false);
    if (response && response?.responseCode === 200) {
      let temp = await response?.data?.map((item, index) => {
        return {
          ...item,
          value: item.id,
          label: item.name,
          checked: false,
        };
      });
      setMasterList(temp);
    } else {
      Toast.error(
        response?.data?.message
          ? response?.data?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  async function loadStoreData(id) {
    if (!id) {
      return;
    }
    setPageLoading(true);
    let response = await getTierById(id, `${APP_CONSTANTS.BASE}`);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data;

      setValues({
        discount: responsedata?.discount,
        name: responsedata?.tierId?.tierMasterName,
        tierId: responsedata?.tierId?.id,
        mallId: responsedata?.mallId?.id,
        minRange: responsedata?.minRange,
        maxRange: responsedata?.maxRange,
        status: responsedata?.status,
        priority: responsedata?.priority,
      });

      let temp = masterList?.map((item) => {
        return {
          ...item,
          checked: item?.id === responsedata?.tierId?.id ? true : false,
        };
      });
      setMasterList([...temp]);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  async function callAddOrUpdateAPI() {
    setPageLoading(true);
    let response = {};
    let senddata = {
      ...values,
    };
    if (supportId) {
      response = await updateTier(
        supportId,
        { ...senddata },
        `${APP_CONSTANTS.BASE}`
      );
    } else {
      const data = [senddata];
      response = await addTier(data);
    }
    setPageLoading(false);
    if (response?.responseCode === 200) {
      Toast.success(
        supportId ? Message.Tier.UPDATED_SUCCESS : Message.Tier.CREATED_SUCCESS
      );
      navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  function handleCreateDefaultTier(e) {
    e.preventDefault();
    const validationErrors = validate(values, defaulttierValidationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }
  function handleChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: name === 'discount' ? parseFloat(value) : parseInt(value),
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }
  function setChange(name, val) {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
    setErrors({
      ...error,
      [name]: '',
    });
  }
  function handleCheckChange(e) {
    const { id, checked } = e.target;
    setErrors({
      ...error,
      tierId: '',
    });
    if (!checked) {
      const updatedMasterList = masterList.map((item) => ({
        ...item,
        checked: false,
      }));
      setMasterList(updatedMasterList);
      setValues((prevValues) => ({
        ...prevValues,
        tierId: '',
        name: '',
      }));
      return;
    }

    const updatedMasterList = masterList.map((item) => ({
      ...item,
      checked: item.id.toString() === id ? true : false,
    }));
    const targetItem = masterList.find((item) => item.id.toString() === id);
    const tempname = targetItem ? targetItem?.name : null;
    setValues((prevValues) => ({
      ...prevValues,
      tierId: id,
      name: tempname,
    }));
    setMasterList([...updatedMasterList]);
  }

  return {
    setChange,
    handleChange,
    values,
    error,
    handleCreateDefaultTier,
    pageLoading,
    supportId,
    mallList,
    masterList,
    navigate,
    handleCheckChange,
  };
};

export default useCreateDefaultTier;
